export default "__VITE_ASSET__ChxLYc9U__"